import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage')({
  beforeLoad: () => getTitleContextSlice('Asset Coverage'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
